import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { EfficiencyData } from '../types';

export const exposeApi = createApi({
  reducerPath: 'exposeApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.API_URL}`,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  }),
  endpoints: (builder) => ({
    getEfficiencyData: builder.query<EfficiencyData, { exposeId: string; modernizationCheck: boolean }>({
      query: (args) => ({
        url: `/modernisierungsrechner/eek/v1/calculate?exposeId=${args.exposeId}&modernizationCheck=${args.modernizationCheck}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetEfficiencyDataQuery, useLazyGetEfficiencyDataQuery } = exposeApi;
